import { Immobile, Trascodifica, Profilo, Transazione, BloccoImmobile } from '.';

export class ServizioAcquistato {
	id: number;
	idImmobile: number;
	idTipologiaServizio: number;
	idSottoTipologiaServizio: number;
	costo: number;
	costoScontato: number;
	dataAcquisto: Date;
	dataErogazione: Date;
	immobile: Immobile;
	tipologiaServizio: Trascodifica;
	sottoTipologiaServizio: Trascodifica;
	idProfilo: number;
	profilo: Profilo;
	erogato: boolean;
	nomeFileFattura: string;
	rating: number;
	ratingCommento: string;
	divClass: string;
	contattoCliente: boolean;
	pagamentoCollaboratore: boolean;
	dataPagamentoCollaboratore: Date;
	blocco: BloccoImmobile;
	transazione: Transazione;

	constructor(idImmobile?: number, idTipologiaServizio?: number, prezzo?: number, idProfilo?: number, idSottoTipologiaServizio?: number) {
		this.idImmobile = idImmobile;
		this.idTipologiaServizio = idTipologiaServizio;
		this.costo = prezzo;
		this.idProfilo = idProfilo;
		this.idSottoTipologiaServizio = idSottoTipologiaServizio;
	}

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/servizio-acquistato.ts